import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import Industry from "./pages/Industry";
import Aviation from "./pages/Aviation"; // Ensure exact case
import Socials from "./pages/Socials";
import Training from "./pages/Training";
import ScrollToTop from "./components/ScrollToTop"; // Import the ScrollToTop component

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Ensure ScrollToTop is added here */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/industry" element={<Industry />} />
        <Route path="/aviation" element={<Aviation />} />
        <Route path="/socials" element={<Socials />} />
        <Route path="/training" element={<Training />} />
      </Routes>
    </Router>


  );
}

export default App;
